import React from 'react';
import './VirtualSuccessUI.css';
import businessLogo from '../../images/business_logo.png';

const VirtualSuccessUI = ({ message, subtitle }) => {
  const response_type = localStorage.getItem("response_type");

  // Different messages based on response type
  const getSuccessContent = () => {
    // If custom message and subtitle are provided, use them (for polling and other custom flows)
    if (message && subtitle) {
      return {
        title: message,
        subtitle: subtitle,
        icon: (
          <svg className="checkmark-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        )
      };
    }

    // Otherwise use response_type-based messages
    if (response_type === "happy") {
      return {
        title: "Thank you for your feedback!",
        subtitle: "We're thrilled to hear about your positive experience. Your feedback helps us continue providing excellent service.",
        icon: (
          <svg className="checkmark-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        )
      };
    } else if (response_type === "sad") {
      return {
        title: "Thank you for your feedback!",
        subtitle: "We sincerely appreciate you taking the time to share your concerns. Your feedback is valuable and will help us improve our services.",
        icon: (
          <svg className="checkmark-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        )
      };
    } else {
      // Default fallback
      return {
        title: "Thank you for your feedback!",
        subtitle: "We appreciate your response and will use it to improve our services.",
        icon: (
          <svg className="checkmark-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        )
      };
    }
  };

  const successContent = getSuccessContent();

  return (
    <div className="virtual-success-container" data-response-type={response_type}>
      <div className="success-message-container">
        <div className="success-icon">
          {successContent.icon}
        </div>
        <h1 className="success-message">{successContent.title}</h1>
        <p className="success-submessage">{successContent.subtitle}</p>
      </div>
      
      <div className="business-logo-container">
        <div className="business-logo-card">
          <img src={businessLogo} alt="Business Logo" className="business-logo" />
        </div>
      </div>
      
      <div className="powered-by-container">
        <a href="https://dashboard.fdbkinsights.com" target="_blank" rel="noopener noreferrer" className="powered-by-link">
          <span>Powered by</span>
          <div className="powered-by-badge">
            <img src="logo.svg" alt="Logo" className="powered-by-logo" />
          </div>
        </a>
      </div>
    </div>
  );
};

export default VirtualSuccessUI;